
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/autopfand-formular/zulassungsjahr",
      function () {
        return require("private-next-pages/autopfand-formular/zulassungsjahr.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/autopfand-formular/zulassungsjahr"])
      });
    }
  